export interface RestPasswordModel {
  newPassword: string
  confirmPassword: string
}

export const ResetPasswordInitValues: RestPasswordModel = {
  newPassword: '',
  confirmPassword: '',
}
